import { Logo } from "./Nav";

export const Footer = () => (
    <footer className="border-t border-[#1f1f1f] bg-[#0a0a0a]" data-testid="footer">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-6 py-12 text-center">
            <Logo />
            <p className="text-sm text-[#6b6b6b]" data-testid="footer-tagline">
                Quikpik · by Allcov · Skip the line. Just Quikpik.
            </p>
        </div>
    </footer>
);
